import React, { useState } from "react";
import "./ProductSection.css";

// Sample image imports (replace with actual paths or import your own)
import img1 from "./kesar peda.png";
import img2 from "./anjir peda.png";
import img3 from "./malai peda.png";
import img4 from "./sitafal barfi.png";
import img5 from "./chiku barfi.png";
import img6 from "./mango barfi.png";
import img7 from "./anjir barfi.png";
import img8 from "./malai barfi.png";
import img9 from "./chocklet barfi.png";
import img10 from "./alu vadi snacks.png";
import img11 from "./sev snacks.png";
import img12 from "./khakhra snacks.png";
import img13 from "./snacks for home page.png";
import img14 from "./anjir kajukatli.png";
import img15 from "./kesar kajukatli.png";
import img16 from "./lauki halva.png";
import img17 from "./gajar halwa.png";
import img18 from "./fancydryfruit3.jpg";
import img19 from "./rosogulla.png";
import img20 from "./rasmalai.png";
import img21 from "./malai sandwich.png";
import img22 from "./dinkladdu2.png";
import img23 from "./Motichoor.jpg";
import img24 from "./milk cake.png";
import img25 from "./gulab jamun.png";
import img26 from "./long gulab jamun.png";
import img27 from "./black guab jamun.png";
import img28 from "./Maisur.jpg";
import img29 from "./mohanthal.jpg";
import img30 from "./gheewar.jpg";
import img31 from "./gheewar2.jpg";
import img32 from "./khaman dhokla.png"
import img33 from "./srekhand.jpg"
import img34 from "./lassi.jpg"
import img35 from "./dahi.png"
import img36 from "./Faluda.jpg"
import img37 from "./kesar puri peda.png"
import img38 from "./maharajahalwa.png"
import img40 from "./icehalva.jpg"
import img41 from "./kajukatli.png"
import img42 from "./dryfruitkatli.jpg"
import img43 from "./MethiLaddu.jpg"
import img44 from "./besanladdu.jpg"
import img45 from "./Rawaladdu.jpg"
import img46 from "./MalaiPuriPeda.jpg"
import img47 from "./JaiphelPeda.jpg"
import img48 from "./RoseBarfi.jpg"
import img49 from "./ButterScotchBarfi.jpg"
import img50 from "./BadamHalwa.jpg"
import img51 from "./AnjirBadamHalwa.jpg"
import img52 from "./DesiBadamHalwa.jpg"
import img53 from "./VilayatiHalwa.jpg"
import img54 from "./AnjirHalwa.jpg"
import img55 from "./PineAppleHalwa.jpg"
import img56 from "./drymotichoor.png"
import img57 from "./AnguriJamun.jpg"
import img58 from "./jalebi.png"
import img59 from "./MalwaniKhaja.jpg"
import img60 from "./BaluShahi.jpg"
import img61 from "./MavaKhaja.jpg"



function ProductSection() {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const products = [
      
    {
      category: "Peda",
      subtypes: [
        { title: "Kesar Peda",img: img1, description: "Made with best Saffron." },
        { title: "Anjir Peda",img: img2, description: "Delightful anjir blend." },
        { title: "Malai Peda",img: img3, description: "Condensed milk, Taste bomb." },
        { title: "Kesar Puri Peda", img: img37, description:""},
        { title: "Malai Puri Peda", img: img46 ,description:"" },
        { title: "Jaiphal Peda", img: img47 , description:""}
      ],
    },

    {
      category: "Barfi",
      subtypes: [
        { title: "Sitafal Barfi",img: img4, description: "Made with condensed milk." },
        { title: "Chiku Barfi",img: img5, description: "Delightful chiku blend." },
        { title: "Mango Barfi",img: img6, description: "Topped with shredded coconut." },
        { title:  "Anjir Barfi", img: img7, description:"Healty & tasty."},
        { title: "Malai Barfi", img: img8, description: "Condensed Milk and our love."},
        { title:"chocolate Barfi", img:img9, description:"Fusion of chocolate with desi Delight"},
        { title: "Milk Cake", img :img24, description:"Something new & Apetizing"},
        { title: "Rose Barfi", img :img48 ,description:""},
        { title: "Butterscotch Barfi", img: img49 ,description:""}
      ],
    },
    {
      category: "Snacks",
      subtypes: [
        { title: "Aluvadi", img: img10, description: "Best Aluvdi you'll ever have." },
        { title: "Sev", img:img11, description: "Crispy and Tasty." },
        { title: "Khakhra", img: img12, description: "Crispy Gujarati snack." },
        { title: "Dhokla", img: img32, description: "Spongy and Healthy." },
        { title: "All the Snacks", img: img13, description: "Savory and crispy mixture from samosa to Vade and many more delights." },
      ],
    },
    {
      category: "Kaju Katli",
      subtypes: [
        { title: "Anjir Kaju Katli", img: img14, description: "Premium cashew sweet." },
        { title: "Kesar Kaju Katli", img: img15, description: "Saffron flavored variety." },
        { title: "Sada Kaju Katli", img: img41,description:"Ordinary Katli with Extraordinary Taste."},
        { title: "DryFruit Katli", img:img42, description:"Best in both Taste & Health" }
      ],
    },
    {
      category: "Halwa's",
      subtypes: [
        { title: "Carrot/Gajar Halwa", img: img17, description: "Sweet made from grated carrots." },
        { title: "Lauki Halwa",img: img16, description: "Bottle gourd dessert." },
        { title: "Maharaja Halwa", img: img38, description:"Mix of taste and health"},
        { title: "Ice Halwa", img: img40,description: "Thin pieces of sweet halwa"},
        { title: "Badam Halwa", img: img50, description:"Grounded and whole cashews "},
        { title: "Anjeer Badam Halwa", img: img51 , description:""},
        { title: "Desi Badam Halwa", img: img52 , description:""},
        { title: "Vilayati Halwa", img: img53 , description:""},
        { title: "Anjeer Halwa", img: img54 , description:""},
        { title: "Pineapple Halwa", img: img55 ,description:"" }
      ],
    },
    {
      category: "Fancy Dryfruit",
      subtypes: [
        { title: "Dryfruit Ladoo(top)", img: img18, description: "Power-packed healthy ladoo." },
        { title: "Dryfruit roll(Bottom)", img: img18, description: "Power-packed healthy ladoo." },
      ],
    },
    {
      category: "Bengal Sweets",
      subtypes: [
        { title: "Rasgulla", img: img19, description: "Spongy and syrupy delight." },
        { title: "Ras-Malai", img: img20, description: "Sweet stuffed with khoya." },
        { title: "Malai Sandwich", img: img21, description: "Light Bengali milk sweet." },
      ],
    },
    {
      category: "Laddus",
      subtypes: [
        { title: "Motichoor Ladoo", img: img23, description: "Miniature boondi laddus." },
        { title: "Dink Ladoo", img: img22, description: "Made from sesame seeds and jaggery." },
        { title: "Methi Laddu", img: img43, description:"Healty dish that packs a taste punch."},
        { title: "Besan Laddu",img:img44,description:"You will love this delecacy."},
        { title: "Rawa Laddu",img:img45,description:"Taste that one never Forgets."},
        { title: "Dry Motichoor Laddu", img: img56 , description:""}
      ],
    },
    {
      category: "Dairy Items",
      subtypes: [
        { title: "Srikhand", img: img33, description: "Thickened, sweetened milk." },
        { title: "Lassi", img: img34, description:"Endless Milk Delight"},
        { title: "Dahi", img: img35, description:"Best dahi youll ever have"},
        { title: "Faluda", img: img36, description:"Best faluda youll ever have"},
      ],
    },
    {
      category: "Gulab Jamun",
      subtypes: [
        { title: "Classic Gulab Jamun", img: img25, description: "Soft balls soaked in rose syrup." },
        { title: "Kala Jamun", img: img27, description: "Darker, richer version." },
        { title: "long Gulab Jamun", img: img26, description: "Longer variant with la lot of sugar syrup." },
        { title: "Anguri Gulab Jamun", img: img57 ,description:""}
      ],
    },
    {
      category: "Maisur & Mohan Thal",
      subtypes: [
        { title: "Mysore Pak", img: img28, description: "Rich in ghee and sugar." },
        { title: "Mohanthal", img: img29, description: "Gujarati besan sweet." },
      ],
    },
    {
      category: "Ghewar",
      subtypes: [
        { title: "Plain Ghewar", img: img30, description: "Rajasthani festive sweet." },
        { title: "Malai Ghewar", img: img31, description: "Topped with cream and nuts." },
      ],
    },
    {
      category: "Other Delicacies",
      subtypes: [
        { title: "Jalebi", img: img58, description:""},
        { title: "Malwani Khaja", img: img59, description:""},
        { title: "Balu Shahi", img: img60, description:""},
        { title: "Mawa Khaja", img: img61, description:""},
      ]
    }
  ];

  const categories = ["All", ...products.map((p) => p.category)];

  const filteredProducts =
    selectedCategory === "All"
      ? products.flatMap((p) => p.subtypes)
      : products.find((p) => p.category === selectedCategory)?.subtypes || [];

  return (
    <section className="product-section">
      <h2>Our Range of Delicacy</h2>

      <div className="category-buttons">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`category-btn ${selectedCategory === cat ? "active" : ""}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      

      <div className="product-list">
  {filteredProducts.map((product, index) => (
    <div key={index} className="product-card">
      <img src={product.img} alt={product.title} />
      <h3>{product.title}</h3>
      <p>{product.description}</p>
    </div>
  ))}
</div>

    </section>
  );
}

export default ProductSection;
